import * as React from "react";
function SvgDotCircleOutline(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M12 3.935A8.06 8.06 0 0120.064 12 8.06 8.06 0 0112 20.064 8.06 8.06 0 013.935 12 8.06 8.06 0 0112 3.935zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 6.774a3.226 3.226 0 100 6.452 3.226 3.226 0 000-6.452z"
        fill="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDotCircleOutline);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
